module.exports = __webpack_public_path__ + "img/cartoon.833ad716.png";